/**
 * @Author: Fannie
 * @Date:   2018-04-25T08:55:02+08:00
 * @Last modified by:

 * @Last modified time: 2018-04-25T08:55:02+08:00
 */
import keyMirror from "keymirror";
 export const Employee = {
   ActionTypes: keyMirror({
     // employee home
     FETCHEMPLOYEETIPSSUCCESS: null,
     FETCHEMPLOYEEIMPORTANTTIPSSUCCESS:null,
     CLOSEMPLOYEEIMPORTANTTIPSSUCCESS:null,
     //申请中心
     FETCHLEAVETYPESSUCCESS:null,
     FETCHAPPLICATIONLISTSSUCCESS:null,
     //个人中心
     FETCHPERSONALCENTERSSUCCESS:null,
     //我的薪资
     FETCHMYSALARYSSUCCESS:null,
     //我的考勤详情
     FETCHMYATTENDANCEDETAILSUCCESS:null,
     //移动端我的考勤
     FETCHMYATTENDANCESSUCCESS:null　
    
   })
};


// WEBPACK FOOTER //
// ./src/constants/employee-constants.js